import { Text } from '@enechain/ecloud-designsystem'

/**
 * 入力中の文字数 (`12 / 100`)。schema と同じく前後の空白を除いた文字数 (rune) で数え、
 * 上限を超えたら警告色にする。超過分は削らず、保存時に schema の文言で止める
 * (2026-10-23 DE の画面確認: 黙って削ると登録した名前が変わってしまう)。
 */
export const CharCount = ({
  value,
  max,
}: {
  value: string
  max: number
}): React.ReactElement => {
  const count = Array.from(value.trim()).length
  return (
    <Text
      color={count > max ? 'Text.negativeMid' : 'Text.lowEmphasis'}
      fontSize="sm"
    >{`${count} / ${max}`}</Text>
  )
}
